import { render, staticRenderFns } from "./VueTagger.vue?vue&type=template&id=ef7c2a86"
import script from "./VueTagger.vue?vue&type=script&lang=js"
export * from "./VueTagger.vue?vue&type=script&lang=js"
import style0 from "./VueTagger.vue?vue&type=style&index=0&id=ef7c2a86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports